<template>
  <div id="app">
    <el-container v-if="!isLogin" class="layout">
      <el-header class="topbar">
        <div class="brand">
          <i class="el-icon-s-cooperation brand-icon"></i>
          <span class="brand-title">{{ brandTitle }}</span>
        </div>

        <el-menu
          mode="horizontal"
          :default-active="activeMenu"
          background-color="#001529"
          text-color="#ffffffcc"
          active-text-color="#fff"
          router
          class="nav-menu"
        >
          <!-- 仪表盘 -->
          <el-menu-item index="/dashboard">
            <i class="el-icon-s-data"></i>
            <span>仪表盘</span>
          </el-menu-item>

          <!-- 服务商管理（仅系统管理员可见） -->
          <el-menu-item index="/service-provider/list" v-if="isSystemAdmin">
            <i class="el-icon-s-custom"></i>
            <span>服务商管理</span>
          </el-menu-item>

          <!-- 管理员管理（仅系统管理员可见） -->
          <el-menu-item index="/admin/list" v-if="isSystemAdmin">
            <i class="el-icon-user"></i>
            <span>管理员管理</span>
          </el-menu-item>

          <!-- 小程序管理（仅服务商管理员可见） -->
          <el-menu-item index="/mini-app/list" v-if="isServiceProviderAdmin">
            <i class="el-icon-s-platform"></i>
            <span>小程序管理</span>
          </el-menu-item>

          <!-- 管理员管理（服务商管理员可见） -->
          <el-menu-item index="/mini-app/admin" v-if="isServiceProviderAdmin">
            <i class="el-icon-user"></i>
            <span>管理员管理</span>
          </el-menu-item>

          <!-- 店铺管理（仅小程序管理员可见） -->
          <el-submenu index="/shop" v-if="isMiniAppAdmin">
            <template slot="title">
              <i class="el-icon-s-shop"></i>
              <span>店铺管理</span>
            </template>
            <el-menu-item index="/shop/list">
              <i class="el-icon-s-shop"></i>
              <span>店铺列表</span>
            </el-menu-item>
            <el-menu-item index="/shop/admins">
              <i class="el-icon-user"></i>
              <span>管理员管理</span>
            </el-menu-item>
            <el-menu-item index="/category/list">
              <i class="el-icon-menu"></i>
              <span>分类管理</span>
            </el-menu-item>
            <el-menu-item index="/banner/list">
              <i class="el-icon-picture-outline"></i>
              <span>轮播图管理</span>
            </el-menu-item>
          </el-submenu>

          <!-- 商品管理（小程序管理员可见） -->
          <el-submenu index="/goods" v-if="isMiniAppAdmin">
            <template slot="title">
              <i class="el-icon-goods"></i>
              <span>商品管理</span>
            </template>
            <el-menu-item index="/goods/list">
              <i class="el-icon-goods"></i>
              <span>商品列表</span>
            </el-menu-item>
            <el-menu-item index="/goods/hot">
              <i class="el-icon-star-off"></i>
              <span>热门商品</span>
            </el-menu-item>
          </el-submenu>

          <!-- 订单管理（小程序管理员可见） -->
          <el-submenu index="/order" v-if="isMiniAppAdmin">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>订单管理</span>
            </template>
            <el-menu-item index="/order/list">
              <i class="el-icon-document"></i>
              <span>订单列表</span>
            </el-menu-item>
            <el-menu-item index="/order/rent-bills">
              <i class="el-icon-tickets"></i>
              <span>租金账单</span>
            </el-menu-item>
            <el-menu-item index="/order/rent-settlement">
              <i class="el-icon-date"></i>
              <span>月度结算</span>
            </el-menu-item>
            <el-menu-item index="/order/compensation">
              <i class="el-icon-warning-outline"></i>
              <span>赔付审核</span>
            </el-menu-item>
          </el-submenu>



          <!-- 用户管理（小程序管理员可见） -->
          <el-menu-item index="/user/list" v-if="isMiniAppAdmin">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </el-menu-item>
        </el-menu>

        <div class="topbar-right">
          <el-dropdown @command="handleUserCommand">
            <span class="user-info">
              <i class="el-icon-user-solid"></i>
              {{ username }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="main-content">
        <router-view />
        <!-- 全局操作加载遮罩 -->
        <div class="global-loading-overlay" v-if="pageLoading">
          <div class="global-loading-mask"></div>
          <div class="global-loading-content">
            <i class="el-icon-loading global-loading-icon"></i>
            <span>处理中，请稍候...</span>
          </div>
        </div>
      </el-main>
    </el-container>
    <router-view v-else />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      username: '',
      roleType: '',
      serviceProviderName: '',
      miniAppName: '',
      miniAppAppId: '',
      pageLoading: false
    }
  },
  computed: {
    isLogin() {
      return this.$route.path === '/login'
    },
    isSystemAdmin() {
      return this.roleType === 'SYSTEM_ADMIN'
    },
    isServiceProviderAdmin() {
      return this.roleType === 'SERVICE_PROVIDER'
    },
    isMiniAppAdmin() {
      return this.roleType === 'PLATFORM'
    },
    brandTitle() {
      if (this.isSystemAdmin) return '循环经济-租赁行业平台'
      if (this.isServiceProviderAdmin) return '服务商-' + (this.serviceProviderName || '未知')
      if (this.isMiniAppAdmin) {
        const name = this.miniAppName || '未知'
        const appId = this.miniAppAppId ? `(${this.miniAppAppId})` : ''
        return '小程序-' + name + appId
      }
      return '租赁管理系统'
    },
    activeMenu() {
      const path = this.$route.path
      // 精确匹配
      const exactMap = {
        '/shop/list': '/shop/list',
        '/shop/admins': '/shop/admins',
        '/category/list': '/category/list',
        '/banner/list': '/banner/list',
        '/mini-app/list': '/mini-app/list',
        '/mini-app/admin': '/mini-app/admin',
        '/service-provider/list': '/service-provider/list',
        '/service-provider/mini-app': '/mini-app/list',
        '/service-provider/admin': '/mini-app/admin',
        '/order/list': '/order/list',
        '/order/rent-bills': '/order/rent-bills',
        '/goods/list': '/goods/list',
        '/goods/hot': '/goods/hot',
        '/order/rent-settlement': '/order/rent-settlement',
        '/order/compensation': '/order/compensation'
      }
      if (exactMap[path]) return exactMap[path]
      // 模糊匹配
      if (path.startsWith('/order/detail')) return '/order/list'
      return path
    },
    activeSubmenu() {
      const path = this.$route.path
      if (path.startsWith('/shop') || path.startsWith('/category') || path.startsWith('/banner')) return '/shop'
      if (path.startsWith('/goods')) return '/goods'
      if (path.startsWith('/service-provider')) return '/service-provider'
      if (path.startsWith('/mini-app')) return '/mini-app'
      if (path.startsWith('/order')) return '/order'
      return ''
    },
    pageTitle() {
      const titles = {
        '/dashboard': '仪表盘',
        '/service-provider/list': '服务商列表',
        '/service-provider/admin': '管理员管理',
        '/mini-app/list': '小程序列表',
        '/mini-app/admin': '管理员管理',
        '/shop/list': '店铺列表',
        '/shop/admins': '管理员管理',
        '/goods/list': '商品管理',
        '/order/list': '订单管理',
        '/order/rent-bills': '租金账单',
        '/order/rent-settlement': '月度结算',
        '/order/compensation': '赔付审核',
        '/banner/list': '轮播图管理',
        '/category/list': '分类管理'
      }
      if (this.$route.path.startsWith('/order/detail')) {
        return '订单详情'
      }
      return titles[this.$route.path] || '租赁管理系统'
    }
  },
  created() {
    this.loadUserInfo()
    this.setupGlobalLoading()
  },
  watch: {
    '$route.path'() {
      if (!this.isLogin) {
        this.loadUserInfo()
      }
    }
  },
  methods: {
    setupGlobalLoading() {
      const vm = this
      window.__showPageLoading = () => {
        vm.pageLoading = true
      }
      window.__hidePageLoading = () => {
        vm.pageLoading = false
      }
    },
    loadUserInfo() {
      const adminInfo = localStorage.getItem('admin_info')
      if (adminInfo) {
        try {
          const info = JSON.parse(adminInfo)
          this.username = info.admin?.realName
            ? `${info.admin.realName}（${info.admin.username}）`
            : (info.admin?.username || '')
          this.roleType = info.admin?.roleType || ''
          this.serviceProviderName = info.serviceProviderName || ''
          this.miniAppName = info.miniAppName || ''
          this.miniAppAppId = info.miniAppAppId || ''
        } catch (e) {
          console.error('解析用户信息失败', e)
        }
      }
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_info')
          this.$router.push('/login')
        }).catch(() => {
          // 用户取消
        })
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}

.layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.topbar {
  background: linear-gradient(135deg, #001529 0%, #002140 100%) !important;
  display: flex;
  align-items: center;
  padding: 0 28px !important;
  height: 64px !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  position: sticky;
  top: 0;
  z-index: 2000;
  flex-shrink: 0;
}

.brand {
  display: flex;
  align-items: center;
  margin-right: 36px;
  flex-shrink: 0;
}

.brand-icon {
  font-size: 26px;
  color: #1677FF;
  margin-right: 10px;
  background: rgba(22, 119, 255, 0.18);
  padding: 6px 8px;
  border-radius: 8px;
}

.brand-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
}

.nav-menu {
  flex: 1;
  border-bottom: none !important;
  display: flex;
  background: transparent !important;
  overflow: hidden;
  min-width: 0;
}

.el-menu--horizontal.nav-menu > .el-menu-item,
.el-menu--horizontal.nav-menu > .el-submenu > .el-submenu__title {
  height: 64px !important;
  line-height: 64px !important;
  border-bottom: 2px solid transparent !important;
  font-size: 14px;
  color: #ffffffcc !important;
  background-color: transparent !important;
  padding: 0 20px !important;
}

.el-menu--horizontal.nav-menu > .el-submenu {
  float: none !important;
  display: inline-block !important;
}

.el-menu--horizontal.nav-menu > .el-submenu > .el-submenu__icon-arrow {
  color: #ffffffcc !important;
  margin-left: 4px !important;
  top: 50% !important;
  margin-top: -6px !important;
}

.el-menu--horizontal.nav-menu > .el-menu-item i,
.el-menu--horizontal.nav-menu > .el-submenu > .el-submenu__title i {
  color: inherit !important;
  margin-right: 6px !important;
  font-size: 16px;
}

.el-menu--horizontal.nav-menu > .el-menu-item:hover,
.el-menu--horizontal.nav-menu > .el-submenu > .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
  border-bottom-color: #1677FF !important;
}

.el-menu--horizontal.nav-menu > .el-menu-item.is-active,
.el-menu--horizontal.nav-menu > .el-submenu.is-active > .el-submenu__title {
  background-color: rgba(22, 119, 255, 0.3) !important;
  color: #fff !important;
  border-bottom-color: #1677FF !important;
}

.el-menu--horizontal.nav-menu > .el-menu-item.is-active i,
.el-menu--horizontal.nav-menu > .el-submenu.is-active > .el-submenu__title i {
  color: inherit !important;
}

.nav-menu >>> i {
  margin-right: 6px;
  font-size: 16px;
}

.el-menu--popup,
.el-submenu .el-menu {
  background-color: #fff !important;
  border: 1px solid #e4e7ed !important;
  border-radius: 6px !important;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12) !important;
  padding: 6px 0 !important;
  min-width: 180px !important;
}

.el-menu--popup .el-menu-item,
.el-submenu .el-menu .el-menu-item,
.el-submenu .el-submenu__title {
  background-color: #fff !important;
  color: #303133 !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 20px !important;
  font-size: 14px !important;
}

.el-menu--popup .el-menu-item:hover,
.el-submenu .el-menu .el-menu-item:hover,
.el-submenu .el-submenu__title:hover {
  background-color: #ecf5ff !important;
  color: #1677FF !important;
}

.el-menu--popup .el-menu-item.is-active,
.el-submenu .el-menu .el-menu-item.is-active {
  background-color: #1677FF !important;
  color: #fff !important;
}

.topbar-right {
  flex-shrink: 0;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid rgba(255,255,255,0.1);
}

.user-info {
  cursor: pointer;
  color: #ffffffcc;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.user-info:hover {
  color: #fff;
}

.el-dropdown-menu__item {
  color: #303133 !important;
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 42px !important;
  line-height: 42px !important;
}

.el-dropdown-menu__item:hover {
  background-color: #ecf5ff !important;
  color: #1677FF !important;
}

.el-dropdown-menu,
.el-popper {
  border-radius: 8px !important;
  border: 1px solid #e4e7ed !important;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12) !important;
  padding: 6px 0 !important;
}

.main-content {
  background: #f5f7fa !important;
  flex: 1;
  padding: 24px !important;
  overflow-y: auto;
}

/* 全局操作加载遮罩 */
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.global-loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  pointer-events: auto;
}

.global-loading-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: #fff;
  padding: 24px 40px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
}

.global-loading-icon {
  font-size: 32px;
  color: #1677FF;
}
</style>
